import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { TaskFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import TasksListComponent from '../../../components/Tasks/TasksListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function TasksRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new TaskFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Tareas</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={TasksListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}
